export default __webpack_public_path__ + "static/media/image1.c2ff60e7.png";